import PropTypes from 'prop-types'
import AddToListModal from './AddToListModal'

export default function AddAllocatorToListModal({
  visible,
  allocators,
  onClose,
}) {
  // This Modal needs to support adding allocators to lists by either companyId or companyContactId

  const listLinkName = allocators[0]?.companyContactId
    ? 'toCompanyContactId'
    : 'toCompanyId'

  return (
    <AddToListModal
      visible={visible}
      onClose={onClose}
      targetItems={allocators}
      getTargetId={(allocator) =>
        allocator.companyContactId
          ? allocator.companyContactId
          : allocator.companyId
      }
      getTargetName={(allocator) => allocator.companyName}
      listLinkName={listLinkName}
    />
  )
}

AddAllocatorToListModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  allocators: PropTypes.arrayOf(
    PropTypes.shape({
      companyId: PropTypes.number,
      companyContactId: PropTypes.number,
      companyName: PropTypes.string.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
}
